import { RichEditorContextProvider } from '@eastcoal/editor/components/ContextProvider'

import { useLexicalConfig } from '../../editor/hooks/useLexicalConfig'
import { useStoreConfig } from '../../editor/hooks/useStoreConfig'
import { ContractDesignerEditorStoreProvider } from '../../editor/Store'
import { ContractDesignerEditorTracer } from '../EditorTracer'
import { ContractDesignerStoreProvider } from '../Store'

import { ContractDesignerLayout } from './Layout'

export const ContractDesigner = () => {
  const lexicalConfig = useLexicalConfig()
  const storeConfig = useStoreConfig()

  return (
    <RichEditorContextProvider
      lexicalConfig={lexicalConfig}
      storeConfig={storeConfig}
    >
      <ContractDesignerStoreProvider>
        <ContractDesignerEditorStoreProvider>
          <ContractDesignerLayout />
          <ContractDesignerEditorTracer />
        </ContractDesignerEditorStoreProvider>
      </ContractDesignerStoreProvider>
    </RichEditorContextProvider>
  )
}
